var _path;
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.077 4.077A2.072 2.072 0 0020 2a2.072 2.072 0 00-2.077 2.077v13.846H4.077A2.072 2.072 0 002 20c0 1.151.926 2.077 2.077 2.077h13.846v13.846C17.923 37.074 18.85 38 20 38a2.072 2.072 0 002.077-2.077V22.077h13.846C37.074 22.077 38 21.15 38 20a2.072 2.072 0 00-2.077-2.077H22.077V4.077z"
  })));
}
export default SvgAdd;